import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import CompEarnCrazyPointsContent from "@/components/shop-info/EarnCrazyPointsContent"
import styles from "@/styles/article/return-policy.module.scss"
export default function EarnCrazyPoints() {

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-return-policy']}`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <CompEarnCrazyPointsContent></CompEarnCrazyPointsContent>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}